(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/core-js/number/is-safe-integer', 'babel-runtime/helpers/slicedToArray', './consts', '../util/lang'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/number/is-safe-integer'), require('babel-runtime/helpers/slicedToArray'), require('./consts'), require('../util/lang'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.isSafeInteger, global.slicedToArray, global.consts, global.lang);
    global.utils = mod.exports;
  }
})(this, function (exports, _isSafeInteger, _slicedToArray2, _consts, _lang) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isSliceIndex = exports.isIndex = exports.getSliceBounds = exports.getSliceBound = undefined;
  exports.pathAlreadyApplied = pathAlreadyApplied;

  var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var getSliceBound = exports.getSliceBound = function getSliceBound(value, length) {
    if (value < 0) return Math.max(length + value, 0);
    return value;
  };

  /**
   * Get the actual bounds of a slice.
   * @function
   * @memberof path
   * @param {Array<number>} bounds The bounds of the slice
   * @param {number} length The length of the actual array
   * @returns {Array<number>} The actual bounds of the slice
   * @private
   * @since 1.0.0
   */
  var getSliceBounds = exports.getSliceBounds = function getSliceBounds(_ref, length) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        start = _ref2[0],
        end = _ref2[1];

    return [getSliceBound(start, length), getSliceBound(end === undefined ? length : end, length)];
  };

  /**
   * This is an alias for {@link util/isNaturalInteger}.
   * @function
   * @memberof path
   * @private
   * @since 1.0.0
   */
  var isIndex = exports.isIndex = _lang.isNaturalInteger;

  /**
   * Tests whether <code>arg</code> is a valid slice index, that is an integer or <code>undefined</code>.
   * @function
   * @param {*} arg The value to test
   * @return {boolean} True if <code>arg</code> is a valid slice index, false otherwise
   * @memberof path
   * @private
   * @since 1.0.0
   */
  var isSliceIndex = exports.isSliceIndex = function isSliceIndex(arg) {
    return arg === undefined || (0, _isSafeInteger2.default)(arg);
  };

  /**
   * Tests whether <code>path</code> has already been applied using a list of already applied paths.
   * @param {Array} path The path to test.
   * @param {Array} pAppliedPaths Already applied paths.
   * @returns {boolean} <code>true></code> if <code>path</code> has already been applied, <code>false</code> otherwise.
   * @memberof path
   * @private
   * @since 1.0.0
   */
  function pathAlreadyApplied(path, pAppliedPaths) {
    if (pAppliedPaths === undefined) return false;
    var appliedPaths = pAppliedPaths.filter(function (appliedPath) {
      return !appliedPath.some(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
            propType = _ref4[0];

        return propType === _consts.slice || propType === _consts.list;
      });
    });
    if (appliedPaths.length === 0) return false;
    if (path.length === 0 && appliedPaths.length !== 0) return true;
    return appliedPaths.some(function (appliedPath) {
      return pathIncludes(appliedPath, path);
    });
  }

  function pathIncludes(path, otherPath) {
    if (otherPath.length > path.length) return false;
    return otherPath.every(function (_ref5, i) {
      var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
          otherProp = _ref6[1];

      var _path$i = (0, _slicedToArray3.default)(path[i], 2),
          prop = _path$i[1];

      return prop === otherProp;
    });
  }
});